import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Sister Properties banner',
    },
  },
};

export function SisterPropertiesHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="sisterpropertieshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Sister Properties banner"
    >
      <InnerPageHeroSubtitle path="sisterpropertieshero.subtitle" />
      <RichTextContent
        path="sisterpropertieshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken
        path="sisterpropertieshero.subtitle"
        type="richtext"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      >
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="sisterpropertieshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SisterPropertiesHero',
  displayName: 'Sister Properties Hero',
  tokens: {
    'sisterpropertieshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Sister Properties</p>',
    },
    'sisterpropertieshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Nearby Communities From Our Family</p>',
    },
  },
  slotGroups: {
    'sisterpropertieshero.bg_image': bgImageDef,
  },
};

(SisterPropertiesHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default SisterPropertiesHero;
